import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';
import { keepIssuesOfVisibleProcesses } from '../model';
import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import { get as getEffects } from 'serviceWorker/db/fieldValues/effects/effects';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  const effects = {};
  const effectsMap = (await getEffects()).reduce((map, effect) => {
    map.set(effect._id, {
      _id: effect._id,
      label: effect.label,
    });
    return map;
  }, new Map<string, LabelledEntity>());

  const filteredIssues = keepIssuesOfVisibleProcesses(
    filterIssuesByChartFilters(
      issues,
      IssueChart.hsEffect,
      filters,
      timezone
    ),
    additionalParams
  );

  const reducedToEffectsSummary = filteredIssues.reduce<HashMap<number>>(
    (result, issue) => {
      const { effect } = issue.extendedData;

      if (!effect) {
        increaseNoneSeries(result, effects);
      } else {
        increaseEntitySeries(result, effects, effectsMap.get(effect)!);
      }
      return result;
    },
    {}
  );

  return toSortedValuesAndLabels(reducedToEffectsSummary, effects);
}
